import React, {cloneElement, useEffect, useState} from "react";
import i18n from '../../i18n';
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import {withStyles} from "@material-ui/core";
import TableRowCollapse from "./TableRowCollapse";
import Icon from "@material-ui/core/Icon";
import IconButton from "@material-ui/core/IconButton";
import {matchString} from '../Form/utils';
import _ ,{cloneDeep} from 'lodash';


const compareStrings = (value, input) => {
    if(typeof value === 'string' && typeof input === 'string') {
        value = value.toLowerCase();
        input = input.toLowerCase();

        let match = value.startsWith(input);

        if(!match) {
            match = matchString( input, value);
        } else {
            match = 0;
        }
        return match !== -1;
    }
}

const findInValues = (buildings, filter ) => {
    return buildings.filter((building) => {
        let match = false;
        if(building.projects && building.projects.length) {
            building.projects = building.projects.filter((item) => {
                if(item.project.number_internal) {
                    match = compareStrings(item.project.number_internal, filter );
                }
                if(!match && item.project.name) {
                    match = compareStrings(item.project.name,filter);
                }
                if(!match && item.project.contacts && item.project.contacts.length) {
                    item.project.contacts = item.project.contacts.filter(
                        item => compareStrings(item.contact.company_name, filter )
                    );
                    match = !!item.project.contacts.length;
                }
                return match;
            } );
            match = !!building.projects.length;
        }
        if(!match && building.builder) {
            match = compareStrings(building.builder.company_name, filter);
        }
        return building.projects.length;
    },[filter]);
}

const BuildingSubTable = ({buildings, detail, search, classes}) => {

    const [showAll,setShowAll] = useState(false);
    const changShowAll = e => setShowAll(e);
    //const handleClick = () => {
    //    setShowAll(!showAll);
    //}

    const [subordinates,setSubordinates] = useState( buildings );
    const changeSubordinates = (buildings) => {
        setSubordinates(buildings);
    }
    const [searchChanged, setSearchChanged] = useState(false);

    useEffect(()=>{
        setSearchChanged(search);
        if(search && search !== searchChanged){
            if(search.length >= 2) {
                let result = findInValues( cloneDeep(buildings) ,search);
                changeSubordinates(result);
                setShowAll(true);
            }
        } else {
            changeSubordinates( buildings );
            changShowAll(false);
        }
    },[search]);

    return (
        <React.Fragment>
            { subordinates
                ? <Table className={classes.list}>
                    <TableHead>
                        <TableRow>
                            {detail && (
                                <TableCell align={'center'} style={{width:120}}>
                                    {i18n.get('deficiency.self_plural')}
                                    {/*<IconButton
                                        className={classes.iconButton}
                                        component={'a'}
                                        onClick={handleClick} aria-label="expand row" size="small">
                                        <Icon className={classes.iconButtonIcon}>
                                            {showAll ? 'expand_less' : 'expand_more' }
                                        </Icon>
                                    </IconButton>*/}
                                </TableCell>
                            )}
                            <TableCell>
                                {i18n.get('building.house')}
                            </TableCell>
                            <TableCell>
                                {i18n.get('building.address')}
                            </TableCell>
                            <TableCell align="center">{i18n.get('building.actions.self')}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {subordinates.map( (building) => (
                            <TableRowCollapse key={`building_${building.id}`} values={building} detail={detail} show={showAll} search={search} />
                        ))}

                    </TableBody>
                </Table>
                : <div>{i18n.get('default.empty')}</div>
            }
        </React.Fragment>
    )
};

const styles = theme => ({
    list: {
        "& tr": {
            height:40,
        },
        "& td" : {
            paddingTop:0,
            paddingBottom:0,
        },
        "& a": {
            padding:2,
        },
    },
});

export default withStyles(styles)(BuildingSubTable);
